import type { Theme } from '@mui/material/styles'
import { PaymentTiming } from '@/domain/payment/payment-timing'

export {
  PaymentTiming,
  PaymentTimingLabel,
  getPaymentTimingLabel,
  inferCodFromPaymentMethod,
  isCodPaymentTiming,
  isCodPaymentTimingQueryParam,
  isPrepaidPaymentTiming,
  parsePaymentTiming,
  paymentTimingToCode,
  resolvePaymentTimingForCheckout,
  resolvePaymentTimingFromOrder,
} from '@/domain/payment/payment-timing'

/** Single source of truth for payment timing → theme accent color. */
export function getPaymentTimingColor(
  timing: PaymentTiming,
  theme: Pick<Theme, 'palette'>
): string {
  switch (timing) {
    case PaymentTiming.BeforeFulfillment:
      return theme.palette.success.main
    case PaymentTiming.AtDelivery:
      return theme.palette.warning.main
    case PaymentTiming.AtPickup:
      return theme.palette.info.main
    default:
      return theme.palette.text.disabled
  }
}
